import React from 'react';
import Header from '../../components/header';
import HeaderBackButton from '../../components/header-back-button';
import Link from '../../components/link/internal-link';
import headerStyles from '../../components/header/header.scss';
import styles from './post-mobile-header.scss';

const PostMobileHeader = props => {
  const left = (
    <div className={headerStyles.left}>
      <div className={styles.backButton}>
        <HeaderBackButton arrow text="post-mobile-header.back-button-label" component={Link} to="/" />
      </div>
    </div>
  );

  return <Header left={left} {...props} />;
};

export default PostMobileHeader;
